// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Credential } from '@daml.js/dtc-credential/lib/Dtc/Credential/V3/Credential';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useLedgerEnd } from '../ledger/useLedgerEnd';

const useCredentials: () => UseQueryResult<TemplateContract<Credential>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryCredentials', offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryCredentials(offset!);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useCredentials;
